import './bootstrap';
import {initUsersIndex} from "./users";
import {initUsersCreate} from "./users/create";
import {initUsersEdit} from "./users/edit";
import {afterComponentLoadBootstrap} from "./bootstrap";
import {registerDevelopmentComponents} from "./development/registerDevelopmentComponents";
import {initSourcePhonesIndex} from "./source-phones";
import {initSourcePhonesCreate} from "./source-phones/create";
import {initSourcePhonesEdit} from "./source-phones/edit";
import {initCallsIndex} from "./calls";
import {initSmsIndex} from "./sms";
import {initBlacklistIndex} from "./blacklist";

const componentMap = {
	'admin.users.index': {
		action: initUsersIndex,
	},
	'admin.users.create': {
		action: initUsersCreate,
	},
	'admin.users.edit': {
		action: initUsersEdit,
	},

	'admin.source-phones.index': {
		action: initSourcePhonesIndex,
	},
	'admin.source-phones.create': {
		action: initSourcePhonesCreate,
	},
	'admin.source-phones.edit': {
		action: initSourcePhonesEdit,
	},

	// Calls
	'admin.calls.index': {
		action: initCallsIndex,
	},

	// SMS
	'admin.sms.index': {
		action: initSmsIndex,
	},

	// Blacklist
	'admin.blacklist.index': {
		action: initBlacklistIndex
	}
};

// Register development components
registerDevelopmentComponents(componentMap);

document.addEventListener('DOMContentLoaded', () => {
	// Init components
	if (window.jsComponents) {
		window.jsComponents.forEach(componentKey => {
			if (componentMap[componentKey]) {
				componentMap[componentKey].action();
			} else {
				console.error(`"${componentKey}" component not found`);
			}
		})
	}

	afterComponentLoadBootstrap()
})
